import React, { ComponentProps, ComponentType } from 'react';

import ReactContentLoader from 'react-content-loader';

import theme from '@adsk/alloy-react-theme';

/**
 * A ContentLoader provides wrapper for react-content-loader
 * API: https://github.com/danilowoz/react-content-loader
 */
const ContentLoader: ComponentType<ComponentProps<typeof ReactContentLoader>> =
  ({ height, width, children, ...props }) => {
    return (
      <ReactContentLoader
        speed={2}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        backgroundColor={theme.colors.charcoal100}
        foregroundColor={theme.colors.charcoal200}
        {...props}
      >
        {children}
      </ReactContentLoader>
    );
  };

ContentLoader.displayName = 'ContentLoader';

ContentLoader.propTypes = {
  ...ReactContentLoader.propTypes,
};
export default ContentLoader;
